// extracted by mini-css-extract-plugin
export default {"container":"NoRolePage_container__tg9SY","message_container":"NoRolePage_message_container__YPa1q","message":"NoRolePage_message__1-PmE"};